import clsx from 'clsx'
import React, { useEffect } from 'react'

import { PurchaseTypes, type PurchaseType } from '@/constants/programs'
import { formatPrice } from '@/utilities/number'

import './Actions.scss'
import { ADD_TO_CART_BUTTON_UPDATED } from '@/constants/sticky-cta-events'

type Props = {
  price: number
  purchaseType?: PurchaseType
  isActive?: boolean
  onAtcClick: () => void
}

export const Actions: React.FC<Props> = ({
  isActive = false,
  price,
  purchaseType,
  onAtcClick,
}) => {
  const actionText =
    purchaseType === PurchaseTypes.SUBSCRIPTION ? 'Subscribe' : 'Add to bag'
  const formattedPrice = formatPrice(price)
  const priceText =
    purchaseType === PurchaseTypes.SUBSCRIPTION
      ? `${formattedPrice} weekly`
      : formattedPrice
  const activeText = `${actionText} | ${priceText}`
  const inactiveText = 'Enter delivery zip code'

  const text = isActive ? activeText : inactiveText

  useEffect(() => {
    document.dispatchEvent(
      new CustomEvent(ADD_TO_CART_BUTTON_UPDATED, {
        detail: {
          textContent: text,
          isDisabled: !isActive,
        },
      }),
    )
  }, [text])

  const classes = ['program-actions', !isActive && 'program-actions--disabled']

  return (
    <div className={clsx(classes)}>
      <button
        className="program-actions__button button button--primaryArrow"
        disabled={!isActive}
        onClick={onAtcClick}
      >
        {text}
      </button>
    </div>
  )
}
